module.exports = __webpack_public_path__ + "img/logo.be427a7c.png";